export const navigation = [
  { label: "Início", to: "/" },
  { label: "Produtos", to: "/produtos" },
  { label: "Encomendas", to: "/encomendas" },
  { label: "Sobre nós", to: "/sobre" },
  { label: "Contactos", to: "/contactos" },
] as const;
